/* QUANTICA · Articulo del blog.
 *
 * Levantado del <script> de QUANTICA_articulo_3.html. Se le sacaron dos
 * bloques que en el theme los resuelve otro archivo:
 *
 *   - el auto-ocultado del header, que hace q-head.js para todo el sitio,
 *   - el menu mobile, que es el del header del theme.
 *
 * Queda lo propio del articulo: normalizar lo que emite el editor, armar
 * el indice, la barra de progreso con su scrollspy, compartir y el
 * respaldo de imagen que no carga.
 *
 * VA CON defer. El normalizador tiene que correr ANTES de que se recorran
 * los h2 para el indice: el paso 1c convierte los h1 del cuerpo en h2, y
 * si el indice se armara primero esos titulos quedarian afuera.
 */
(function () {
  var doc = document,
    rte = doc.querySelector('.q-rte');

  /* ================================================================
     1. Normalizar lo que escupe el editor de Shopify

     El editor es TinyMCE y lo que emite no coincide con lo que el diseno
     necesita. Esto es lo unico que no se puede deducir mirando el CSS.
     ================================================================ */
  if (rte) {
    /* 1a. <meta charset> y <style> sueltos, que se pegan desde Word. */
    rte.querySelectorAll('meta,style').forEach(function (n) {
      n.remove();
    });

    /* 1b. Parrafos vacios: <p><br></p>, <p>&nbsp;</p>, <p> </p>. El editor
           los usa como aire; el diseno ya tiene su propio ritmo vertical. */
    rte.querySelectorAll('p').forEach(function (p) {
      var t = p.textContent.replace(/\s/g, '');
      if (!t && !p.querySelector('img,iframe,video,svg')) p.remove();
    });

    /* 1c. H1 dentro del cuerpo. La pagina ya tiene su H1, que es el titulo
           del articulo: un segundo H1 rompe la jerarquia para SEO y para el
           lector de pantalla. Se baja a H2 conservando el texto tal cual.
           Conviene igual que el autor arranque en Heading 2. */
    rte.querySelectorAll('h1').forEach(function (h) {
      var n = doc.createElement('h2');
      n.innerHTML = h.innerHTML;
      h.replaceWith(n);
    });

    /* 1d. Imagenes. Llegan envueltas como <p><span><img></span></p>. Se
           sacan del parrafo y se envuelven en <figure>. El alt, si existe,
           se reusa como epigrafe: no hay metafield de donde sacarlo. */
    rte.querySelectorAll('img').forEach(function (img) {
      if (img.closest('figure')) return;
      var fig = doc.createElement('figure');
      var cap = (img.getAttribute('alt') || '').trim();
      var p = img.closest('p');
      /* Si la imagen es el unico contenido de un link, se envuelve el link
         entero: separarlos dejaria la foto sin su destino. */
      var nodo =
        img.parentNode &&
        img.parentNode.tagName === 'A' &&
        img.parentNode.textContent.trim() === ''
          ? img.parentNode
          : img;
      nodo.replaceWith(fig);
      fig.appendChild(nodo);
      if (cap) {
        var fc = doc.createElement('figcaption');
        fc.textContent = cap;
        fig.appendChild(fc);
      }
      /* Un <figure> no puede quedar dentro de un <p>: el parser cierra el
         parrafo y el resto queda como hermano suelto. Se sube un nivel. */
      if (p && p.contains(fig)) {
        p.parentNode.insertBefore(fig, p);
        if (!p.textContent.replace(/\s/g, '') && !p.querySelector('img')) p.remove();
      }
    });

    /* 1e. Tablas. El editor mete width y height inline por celda. El alto
           se neutraliza desde el CSS; el ancho de columna se respeta,
           porque es la proporcion que eligio el autor. Se envuelve para
           que en telefono la tabla deslice sola en vez de romper el ancho
           de la pagina. */
    rte.querySelectorAll('table').forEach(function (t) {
      if (t.closest('.q-tabla')) return;
      t.removeAttribute('height');

      var w = doc.createElement('div'),
        sc = doc.createElement('div');
      w.className = 'q-tabla';
      sc.className = 'q-scroll';
      t.replaceWith(w);
      w.appendChild(sc);
      sc.appendChild(t);

      var marcar = function () {
        w.classList.toggle('desliza', sc.scrollWidth - sc.clientWidth - sc.scrollLeft > 6);
      };
      sc.addEventListener('scroll', marcar, { passive: true });
      window.addEventListener('resize', marcar);
      setTimeout(marcar, 0);

      /* La primera fila se promueve a <thead> SOLO si todas sus celdas son
         <th>, que es lo que pasa cuando el autor marca "Header row" en el
         editor. Promoverla siempre pintaria de verde oscuro la primera
         fila de datos de cualquier tabla sin encabezado. */
      var f1 = t.tBodies[0] && t.tBodies[0].rows[0];
      if (
        f1 &&
        !t.tHead &&
        f1.cells.length &&
        [].every.call(f1.cells, function (c) {
          return c.tagName === 'TH';
        })
      ) {
        t.createTHead().appendChild(f1);
      }
    });
  }

  /* ================================================================
     2. Indice, con los H2 reales del articulo
     ================================================================ */
  var enca = rte ? [].slice.call(rte.querySelectorAll('h2')) : [];
  var caja = doc.querySelector('.qart-toc'),
    cajaM = doc.querySelector('.qart-toc-m');

  /* Una sola seccion no es un indice. Con menos de dos titulos las dos
     cajas se quedan hidden, que es como nacen desde el servidor. */
  var cajas = [caja, cajaM].filter(Boolean);
  var items = [];

  if (enca.length >= 2 && cajas.length) {
    cajas.forEach(function (c) {
      c.hidden = false;
      items.push([]);
    });

    enca.forEach(function (h, i) {
      if (!h.id) {
        var base = (h.textContent || '')
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .slice(0, 48);
        h.id = base ? base + '-' + (i + 1) : 'seccion-' + (i + 1);
      }

      cajas.forEach(function (c, ci) {
        var li = doc.createElement('li');
        var a = doc.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        c.querySelector('ol').appendChild(li);
        /* Una lista por caja, y no todos los <li> en un array unico: la
           version de la referencia los mezclaba y marcaba el activo con
           un desplazamiento de bits que asumia que las dos cajas siempre
           existen. Con una sola, marcaba el titulo equivocado. */
        items[ci].push(li);
      });
    });

    if (cajaM) {
      cajaM.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          cajaM.open = false;
        });
      });
    }
  }

  /* ================================================================
     3. Barra de progreso y scrollspy
     ================================================================ */
  var barra = doc.querySelector('.qart-progress i');
  var art = doc.querySelector('.qart-article');
  var pedido = false;

  function pintar() {
    pedido = false;
    var y = window.scrollY || doc.documentElement.scrollTop;

    /* El progreso se mide sobre el ARTICULO, no sobre la pagina: con el
       hero, los relacionados y el footer contando, la barra llegaba al
       final cuando todavia faltaba medio texto. */
    if (barra && art) {
      var top = art.offsetTop,
        alto = art.offsetHeight - window.innerHeight;
      var pct = alto > 0 ? (y - top) / alto : 0;
      barra.style.transform = 'scaleX(' + Math.min(1, Math.max(0, pct)) + ')';
    }

    if (enca.length >= 2) {
      var act = 0;
      for (var i = 0; i < enca.length; i++) {
        if (enca[i].getBoundingClientRect().top < 160) act = i;
      }
      items.forEach(function (lista) {
        lista.forEach(function (li, k) {
          li.classList.toggle('act', k === act);
        });
      });
    }
  }

  function alScroll() {
    if (!pedido) {
      pedido = true;
      requestAnimationFrame(pintar);
    }
  }

  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', alScroll);
  /* requestAnimationFrame no corre con la pestana oculta, y un cuadro
     pedido justo antes de ocultarla queda pendiente: al volver, la bandera
     seguiria en true y el listener ignoraria todo scroll posterior. */
  doc.addEventListener('visibilitychange', function () {
    if (!doc.hidden) {
      pedido = false;
      pintar();
    }
  });
  pintar();

  /* ================================================================
     4. Compartir
     ================================================================ */
  var url = location.href,
    tit = doc.title;

  doc.querySelectorAll('[data-sh]').forEach(function (a) {
    var k = a.getAttribute('data-sh');
    a.href =
      k === 'mail'
        ? 'mailto:?subject=' + encodeURIComponent(tit) + '&body=' + encodeURIComponent(url)
        : k === 'wa'
          ? 'https://wa.me/?text=' + encodeURIComponent(tit + ' ' + url)
          : 'https://twitter.com/intent/tweet?url=' +
            encodeURIComponent(url) +
            '&text=' +
            encodeURIComponent(tit);
    if (k !== 'mail') {
      a.target = '_blank';
      a.rel = 'noopener';
    }
  });

  doc.querySelectorAll('.qart-copy').forEach(function (b) {
    b.hidden = false;
    b.addEventListener('click', function () {
      var ok = function () {
        var av = b.parentNode.querySelector('.qart-copiado');
        if (!av) return;
        av.classList.add('on');
        setTimeout(function () {
          av.classList.remove('on');
        }, 1600);
      };
      /* navigator.clipboard no existe fuera de contexto seguro, y la vista
         previa del editor del theme no siempre lo es: hace falta el camino
         viejo con execCommand. */
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(ok, ok);
      } else {
        var t = doc.createElement('textarea');
        t.value = url;
        t.setAttribute('readonly', '');
        t.style.cssText = 'position:fixed;top:-100px;opacity:0';
        doc.body.appendChild(t);
        t.select();
        try {
          doc.execCommand('copy');
        } catch (e) {
          /* sin portapapeles no hay confirmacion, pero tampoco error visible */
        }
        doc.body.removeChild(t);
        ok();
      }
    });
  });

  /* ================================================================
     5. Imagen que no carga: caja rotulada en vez del icono roto
     ================================================================ */
  doc.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var cont = img.closest('figure, .ph, .qart-figure');
      if (!cont) return;
      cont.classList.add('sinimg');
      cont.setAttribute('data-falla', 'Image unavailable');
    },
    true
  );
})();
